import React from 'react';
import TableHeaderComponent from '../../components/tableHeaderComponent';
import { useNavigate } from 'react-router-dom';
import sortbydot from '../../../../assets/image/sort_by_group.svg';
import Table from '../../../../component/table/Table';
import PageLoader from '../../../../component/PageLoader';
import Pagination from '../../../../component/pagination';
import AdvanceFilter from '../../../../component/Filter/AdvanceFilter';
import advanceFilterOptions from '../../../../component/Filter/advanceFilterOptions';
import useCustomer from './hooks/useCustomer';
import advanceFilterIcon from '../../../../assets/image/advanceFilter_white.svg';
import clearAllFilter from '../../../../assets/image/clearAllFilter.svg';
import addFilter from '../../../../assets/image/AddFilter.svg';
import { getFiltersParams } from '../../../../helper';
import {
	clearAdvanceFilter,
	removeSelectedInput,
	setAdvanceFilterPage,
	setSelectedInputValue,
} from '../../../../store/action/advanceFilter';
import businessImage from '../../../../assets/image/business_image.png';
import AdvanceFilterSelectInput from '../../../../component/Filter/AdvanceFilterSelectInput';
import ConfirmationModal from '../../../../component/modal/ConfirmationModal';
import DeleteModal from '../../components/deleteModal';
import { IoIosArrowRoundDown, IoIosArrowRoundUp } from 'react-icons/io';
import { ExportTable } from '../../../../store/action/export/Export';
import { hasPermission } from '../../../../utils/controller';
import Button from '../../../../component/ui/Button';
import DataNotFound from '../../../components/dataNotFound';

const Customers = () => {
	const {
		user,
		customersList,
		suburl,
		handlePageChange,
		onRowClick,
		handleDeselectAll,
		FilterDatalist,
		sortDataList,
		handleOnFocusSelectedFilterInput,
		handleApplyFilters,
		searchSelectedInputItems,
		setIsAdvanceFilterOpen,
		isAdvanceFilterOpen,
		isAdvanceFilterApplied,
		selectedInputs,
		setBulkAction,
		bulkAction,
		triggerConfirmationModal,
		deselectRows,
		isLoading,
		isLoader,
		setHeaderDropDown,
		headerDropDown,
		dispatch,
		getModalContent,
		closeModal,
		isMarkAsStatus,
		handleIsActiveStatus,
		handleOpenBulkDeleteCustomerModal,
		isDeleteModalOpen,
		setIsDeleteModalOpen,
		selectedCustomerListForDelete,
		handleBulkDelete,
		sortDirection,
		advanceFilterPage,
		advanceFilterPageSize,
		advanceFilterTotalPages,
		customersParams,
		setCustomersParams,
	} = useCustomer();

	const navigate = useNavigate();
	const getModalTitle = () => {
		if (isMarkAsStatus.isStatus === 1) {
			return 'Mark as Activate Customers';
		} else if (isMarkAsStatus.isStatus === 2) {
			return 'Mark as Inactivate Customers';
		}
		return 'Confirm Action';
	};
	const exportTableData = (param) => {
		ExportTable(param);
	};
	const sortIconMap = {
		asc: <IoIosArrowRoundUp />,
		desc: <IoIosArrowRoundDown />,
	};

	const customerTableColumn = [
		{
			field: '',
			headerClass: 'HeaderBg',
			checkboxSelection: true,
			headerCheckboxSelection: true,
			minWidth: 50,
			maxWidth: 50,
			lockPosition: true,
		},
		{
			field: 'CUSTOMERS NAME',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 180,
			flex: 1,
			cellClass: 'left-align',
			headerComponent: () => (
				<div
					className="header-clickable"
					onClick={() => sortDataList({ order_by: 'asc', sort_by: 'name' })}
				>
					<div className="header-inner-55">
						<p className="table-header__label_invoices mb-0">
							CUSTOMER NAME
							<span className="sort-icon">{sortIconMap[sortDirection?.name]}</span>
						</p>
					</div>
				</div>
			),
			cellRenderer: (params) => {
				const data = JSON.parse(params.data['name']);
				return (
					<p className="d-flex align-items-center mb-0">
						{data?.name}
						{data?.status === 2 && (
							<span
								className="badge bg-secondary ms-2"
								style={{ fontSize: '11px', padding: '2px 10px' }}
							>
								Inactive
							</span>
						)}
						{data?.type === 1 && (
							<span className="ms-2">
								<img
									src={businessImage}
									alt="Business"
									width="18"
									height="18"
								/>
							</span>
						)}
					</p>
				);
			},
		},
		{
			field: 'EMAIL',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 130,
			flex: 1,
			cellClass: 'left-align',
			headerComponent: () => (
				<div
					className="header-clickable"
					onClick={() => sortDataList({ order_by: 'asc', sort_by: 'email' })}
				>
					<div className="header-inner-55">
						<p className="table-header__label_invoices mb-0">
							EMAIL
							<span className="sort-icon">{sortIconMap[sortDirection?.email]}</span>
						</p>
					</div>
				</div>
			),
		},
		{
			field: 'MOBILE',
			headerClass: 'HeaderBg right-align',
			cellClass: 'right-align',
			suppressSizeToFit: true,
			minWidth: 108,
			flex: 1,
			headerComponent: () => (
				<div
					className="header-clickable header-right w-100"
					onClick={() => sortDataList({ order_by: 'asc', sort_by: 'mobile' })}
				>
					<div className="header-inner-55">
						<p className="table-header__label_invoices mb-0 mb-0 justify-content-end d-flex align-items-center">
							MOBILE
							<span className="sort-icon">{sortIconMap[sortDirection?.mobile]}</span>
						</p>
					</div>
				</div>
			),
		},
		{
			field: 'RECEIVABLES',
			headerClass: 'HeaderBg right-align',
			cellClass: 'right-align',
			suppressSizeToFit: true,
			minWidth: 90,
			flex: 1,
			headerComponent: () => (
				<div
					className="header-clickable header-right w-100"
					onClick={() => sortDataList({ order_by: 'desc', sort_by: 'receivables' })}
				>
					<div className="header-inner-55">
						<p className="table-header__label_invoices mb-0 mb-0 justify-content-end d-flex align-items-center">
							RECEIVABLES
							<span className="sort-icon">{sortIconMap[sortDirection?.receivables]}</span>
						</p>
					</div>
				</div>
			),
		},
		{
			field: 'UNUSED CREDITS',
			headerClass: 'HeaderBg right-align',
			cellClass: 'right-align',
			suppressSizeToFit: true,
			minWidth: 50,
			flex: 1,
			headerComponent: () => (
				<div
					className="header-clickable header-right w-100"
					onClick={() => sortDataList({ order_by: 'desc', sort_by: 'unused_credit_amount' })}
				>
					<div className="header-inner-55">
						<p className="table-header__label_invoices mb-0 mb-0 justify-content-end d-flex align-items-center">
							<p className="d-none d-lg-block mb-0">UNUSED CREDITS</p>
							<p className="d-block d-lg-none mb-0">CREDITS</p>
							<span className="sort-icon">{sortIconMap[sortDirection?.unused_credit_amount]}</span>
						</p>
					</div>
				</div>
			),
		},
	];

	return (
		<div style={{ overflow: 'auto' }}>
			<TableHeaderComponent
				bulkAction={bulkAction}
				createButton={{
					disabled: !hasPermission('sales.customers.create', user?.role?.role_permissions),
					buttonName: 'Create New Customer',
					handler: () => navigate(`/user/${suburl}/customers-create`),
				}}
				closeButton={{
					showCloseButton: true,
					handler: () => {
						setBulkAction(false);
						setBulkAction([]);
						deselectRows && deselectRows();
					},
				}}
				buttons={[
					{
						id: 1,
						className: 'btn-gray',
						button: 'Print Statement',
						disabled: !hasPermission('sales.customers.statement', user?.role?.role_permissions),
					},
					headerDropDown === 'Inactive Customers' && {
						id: 2,
						className: 'btn-gray',
						button: 'Mark As Active',
						disabled: !hasPermission('sales.customers.edit', user?.role?.role_permissions),
						handler: () => {
							triggerConfirmationModal(1);
						},
					},
					headerDropDown === 'Active Customers' && {
						id: 2,
						className: 'btn-gray',
						button: 'Mark As Inactive',
						disabled: !hasPermission('sales.customers.edit', user?.role?.role_permissions),
						handler: () => {
							triggerConfirmationModal(2);
						},
					},
					headerDropDown === 'All Customers' && {
						id: 2,
						className: 'btn-gray',
						button: 'Mark As Active',
						disabled: !hasPermission('sales.customers.edit', user?.role?.role_permissions),
						handler: () => {
							triggerConfirmationModal(1);
						},
					},
					headerDropDown === 'All Customers' && {
						id: 3,
						className: 'btn-gray',
						button: 'Mark As Inactive',
						disabled: !hasPermission('sales.customers.edit', user?.role?.role_permissions),
						handler: () => {
							triggerConfirmationModal(2);
						},
					},
					{
						id:
							headerDropDown === 'Inactive Customers' || headerDropDown === 'Active Customers'
								? 3
								: 4,
						className: 'btn-gray',
						button: 'Delete',
						disabled: !hasPermission('sales.customers.delete', user?.role?.role_permissions),
						handler: () => handleOpenBulkDeleteCustomerModal(),
					},
				]}
				dropdownButton={
					<div className="dropdown text-end">
						<a
							className="d-block link-dark text-decoration-none dropdown-toggle"
							id="dropdownUser1"
							data-bs-toggle="dropdown"
							aria-expanded="false"
						>
							<p>{headerDropDown}</p>
						</a>
						<ul
							className="dropdown-menu font-14"
							aria-labelledby="dropdownUser1"
							style={{ minWidth: '240px' }}
						>
							<li>
								<a
									className="dropdown-item"
									onClick={() =>
										FilterDatalist('orderBy=product_code&sortBy=asc', '', 'Active Customers')
									}
								>
									Active Customers
								</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									onClick={() =>
										FilterDatalist('filterBy=status&filterValue=1', 'active', 'Duplicate Customers')
									}
								>
									Duplicate Customers
								</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									onClick={() =>
										FilterDatalist('filterBy=crm&filterValue=0', 'crm', 'Inactive Customers')
									}
								>
									Inactive Customers
								</a>
							</li>
							{/* <li>
								<a
									className="dropdown-item"
									onClick={() =>
										FilterDatalist('filterBy=crm&filterValue=0', 'crm', ' OverDue Customers')
									}
								>
									OverDue Customers
								</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									onClick={() =>
										FilterDatalist('filterBy=crm&filterValue=0', 'crm', 'Unpaid Customers')
									}
								>
									Unpaid Customers
								</a>
							</li> */}
						</ul>
					</div>
				}
				advanceFilterButton={
					isAdvanceFilterApplied ? (
						<div>
							<button
								onClick={() => {
									dispatch(clearAdvanceFilter());
									setHeaderDropDown('All Customers');
								}}
								style={{
									background: 'transparent',
									color: '#FF0000',
									fontSize: '14px',
									cursor: 'pointer',
									fontWeight: '600',
									lineHeight: '24px',
								}}
							>
								<img
									src={clearAllFilter}
									alt=""
									style={{ width: '18px', height: '18px', marginRight: '8px' }}
								/>
								Clear All Filters
							</button>
						</div>
					) : (
						<Button
							type="button"
							button="Advanced Filters"
							className="mt-0 px-4 btn-primary"
							onClick={() => setIsAdvanceFilterOpen(true)}
							icon={advanceFilterIcon}
						/>
					)
				}
				moreButton={
					<div className="dropdown text-end ms-3">
						<a
							href="#"
							className="d-block link-dark text-decoration-none"
							id="dropdownUser1"
							data-bs-toggle="dropdown"
							aria-expanded="false"
						>
							<img src={sortbydot} />
						</a>
						<ul
							className="dropdown-menu font-14"
							aria-labelledby="dropdownUser1"
							style={{ minWidth: '240px' }}
						>
							<li>
								<a className="dropdown-item sortBy">Sort By</a>
							</li>
							<li>
								<a
									style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'space-between',
									}}
									className="dropdown-item"
									onClick={() => sortDataList({ order_by: 'asc', sort_by: 'name' })}
								>
									Name
									<span>{sortIconMap[sortDirection?.name]}</span>
								</a>
							</li>
							<li>
								<a
									style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'space-between',
									}}
									className="dropdown-item"
									onClick={() => sortDataList({ order_by: 'asc', sort_by: 'company_name' })}
								>
									Company Name
									<span>{sortIconMap[sortDirection?.company_name]}</span>
								</a>
							</li>
							<li>
								<a
									style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'space-between',
									}}
									className="dropdown-item"
									onClick={() => sortDataList({ order_by: 'asc', sort_by: 'email' })}
								>
									Email
									<span>{sortIconMap[sortDirection?.email]}</span>
								</a>
							</li>
							{/* <li>
								<a
									className="dropdown-item"
									onClick={() => sortDataList({ order_by: 'receivables', sort_by: 'asc' })}
								>
									Receivables
									<span>{sortIconMap[sortDirection?.created_time]}</span>
								</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									onClick={() => sortDataList({ order_by: 'unused_credits', sort_by: 'asc' })}
								>
									Unused Credits
									<span>{sortIconMap[sortDirection?.created_time]}</span>
								</a>
							</li> */}
							<li>
								<a
									style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'space-between',
									}}
									className="dropdown-item"
									onClick={() => sortDataList({ order_by: 'asc', sort_by: 'created_at' })}
								>
									Created Time
									<span>{sortIconMap[sortDirection?.created_at]}</span>
								</a>
							</li>
							<li>
								<a
									style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'space-between',
									}}
									className="dropdown-item"
									onClick={() => sortDataList({ order_by: 'asc', sort_by: 'updated_at' })}
								>
									Last Modified Time
									<span>{sortIconMap[sortDirection?.updated_at]}</span>
								</a>
							</li>
							<li>
								<a
									style={{
										display: 'flex',
										alignItems: 'center',
										padding: '1rem',
										justifyContent: 'space-between',
									}}
									className={`dropdown-item ${!hasPermission('sales.customers.export', user?.role?.role_permissions) ? 'disabled' : ''}`}
									onClick={() => exportTableData('customers')}
								>
									Export Customers
								</a>
							</li>
						</ul>
					</div>
				}
			/>
			<div
				style={{
					display: 'flex',
					alignItems: 'center',
					gap: 10,
					padding: '0px 10px',
				}}
			>
				{isAdvanceFilterApplied && (
					<div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
						{selectedInputs.map((item) => (
							<AdvanceFilterSelectInput
								key={item.key}
								options={item?.data}
								placeholder={`Select ${item?.label}`}
								value={item?.value}
								disabled={false}
								onFocusCb={() => {
									if (item.value === '') {
										handleOnFocusSelectedFilterInput(item?.key);
									}
								}}
								onChange={(value) => {}}
								onSelect={(option) => {
									const updatedSelectedInput = selectedInputs.map((input) => {
										if (input.key === item?.key) {
											return {
												...input,
												value: option?.value,
											};
										}
										return input;
									});
									const params = getFiltersParams(updatedSelectedInput);
									handleApplyFilters(params);
									dispatch(setSelectedInputValue({ key: item?.key, value: option.value }));
								}}
								removeInput={() => {
									dispatch(removeSelectedInput({ key: item?.key }));
									if (item?.key === 'status') {
										setHeaderDropDown('All Customers');
									}
									const params = getFiltersParams(
										selectedInputs.filter((input) => input.key !== item?.key),
									);
									handleApplyFilters(params);
								}}
								className="selectInput"
							/>
						))}
						<div style={{ marginBottom: '8px', cursor: 'pointer' }}>
							<img
								src={addFilter}
								alt="Apply Filter"
								onClick={() => setIsAdvanceFilterOpen(true)}
							/>
						</div>
					</div>
				)}
			</div>
			{isLoading ? (
				<PageLoader />
			) : customersList.data.length > 0 ? (
				<Table
					row={customersList.data}
					coloum={customerTableColumn}
					className="productTable"
					onRowClick={onRowClick}
					bulkAction={bulkAction}
					action={setBulkAction}
					style={isAdvanceFilterApplied ? { height: 'calc(100vh - 185px)' } : {}}
					onDeselectAll={handleDeselectAll}
				/>
			) : (
				<DataNotFound
					title={'Business grows with your connections!'}
					subtitle={'Add customers to manage sales and prescriptions easily.'}
					descriptionTitle={'Stay organized! '}
					descriptionSubTitle={'Add your customer list to begin tracking prescriptions,'}
					descriptionContent={'payments, and invoices — all in one place.'}
					buttonText={'Create New Customer'}
					disabled={!hasPermission('sales.customers.create', user?.role?.role_permissions)}
					onClick={() => navigate(`/user/${suburl}/customers-create`)}
				/>
			)}
			{customersList.data.length > 0 && (
				<Pagination
					currentPage={isAdvanceFilterApplied ? advanceFilterPage : customersParams.page}
					totalPages={isAdvanceFilterApplied ? advanceFilterTotalPages : customersList.totalPages}
					onChangePage={handlePageChange}
					pageSize={isAdvanceFilterApplied ? advanceFilterPageSize : customersParams.page_size}
					setParam={(value) => {
						if (isAdvanceFilterApplied) {
							dispatch(setAdvanceFilterPage({ page: 1, pageSize: value }));
						} else {
							setCustomersParams((prev) => ({
								...prev,
								page_size: value,
								page: 1,
							}));
						}
					}}
				/>
			)}

			{isMarkAsStatus.isModelOpen && (
				<ConfirmationModal
					isOpen={isMarkAsStatus.isModelOpen}
					onClose={closeModal}
					title={getModalTitle()}
					content={getModalContent()}
					onCancel={closeModal}
					onOk={() => {
						handleIsActiveStatus(isMarkAsStatus.isStatus);
						closeModal();
					}}
					loader={isLoader}
				/>
			)}

			{isDeleteModalOpen && (
				<DeleteModal
					isDeleteBulkConfirmationModalOpen={isDeleteModalOpen}
					setIsDeleteBulkConfirmationModalOpen={setIsDeleteModalOpen}
					selectedListForDelete={selectedCustomerListForDelete}
					handleBulkDelete={handleBulkDelete}
					deleteLength={bulkAction.length}
					saleTypeName={'Customers'}
				/>
			)}

			{isAdvanceFilterOpen && (
				<AdvanceFilter
					modalLabel="Note: You can create a bill for either Yet to Receive Items or Received Items."
					isOpen={isAdvanceFilterOpen}
					advanceFilterOptions={advanceFilterOptions?.customers}
					onFocusSelectedFilterInput={handleOnFocusSelectedFilterInput}
					handleOnChangeSelectedFilterInput={(key, value) => searchSelectedInputItems(key, value)}
					onClose={() => {
						setIsAdvanceFilterOpen(false);
					}}
					onApply={handleApplyFilters}
				/>
			)}
		</div>
	);
};
export default Customers;
